<template>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h6
          id="privateSettingLabel"
          class="modal-title"
        >
          {{ title }}
        </h6>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div
        v-if="warningText"
        class="d-flex align-items-center bg-warning px-3 py-2"
      >
        <i class="gf-icon gf-icon-warning mr-1" />
        {{ warningText }}
      </div>

      <div class="modal-body">
        <slot />
      </div>

      <div class="modal-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupWrapper',
  props: {
    modalId: {
      default: null
    },
    title: {
      default: ''
    },
    warningText: {
      default: null
    }
  },
  mounted() {},
  methods: {}
};
</script>
